import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { MachineLicensesList } from "../../components/licenses/machinelicenses/MachineLicensesList";

// To Do: Add BreadCrum
// Add Translation
export const MachineLicenses: React.FC = () => {
  const { t } = useTranslation();
  //const breadcrumb = useBreadcrumb("orders");


  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.machinelicenses")}
        />

      }
    >

      <MachineLicensesList />
    </MainContentArea>
  );
};
